import clearfix from '../../styles/tools/clearfix'
import breakTo from '../../styles/tools/breakTo'
import grid from '../../styles/tools/grid'

export default ({ colors, images, spacings, fontWeights }) => ({
  footer: {
    ...clearfix(),

    position: 'relative',

    marginTop: spacings.x4,

    backgroundColor: colors.footer.bg
  },

  link: {
    fontWeight: fontWeights.semibold,
    color: colors.footer.link,

    ':hover': {
      color: colors.footer.linkHover
    },
    ':visited': {
      color: colors.footer.link
    },
    ':active': {
      color: colors.footer.link
    },
    ':focus': {
      color: colors.footer.link
    }
  },
  links: {
  display: 'flex',
  flexDirection: 'row',
  gap: '16px',//var(--structure-header-blocks-gap-v, 16px);
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  alignContent: 'flex-start',
  alignSelf: 'stretch',
  flexShrink: '0',
  position: 'relative'
},
textualLinks: {
  display: 'flex',
  flexDirection: 'row',
  gap: '16px',//var(--structure-header-blocks-gap-h, 16px);
  rowGap: '24px',
  alignItems: 'center',
  justifyContent: 'flex-start',
  flexWrap: 'wrap',
  alignContent: 'center',
  flex: '1',
  position: 'relative',
  padding: '16px 0px 16px 0px'
},
privacyPolicy :{
  color: '#0087d6',//var(--surfaces-footer-pre-login-light-bg-content-primary,rgba(0, 0, 0, 0.6));
  textAlign: 'left',
  fontFamily: 'Rethink Sans',//var(--typography-font-family-secondary,"RethinkSans-Medium",sans-serif);
  fontSize: '11px',//var(--titles-and-paragraphs-font-sizes-paragraphs-default, 14px);
  fontWeight: '500',
  textDecorationLine: 'underline',
  position: 'relative',
  padding: '4px',
  cursor: 'pointer'
  
},

  // This container should contain everything inside the footer.
  // Also provide a centered position.
  container: {
    ...clearfix()
  },

  // The footer columns.
  section: {
    display: 'block',

    paddingLeft: spacings.default
  },

  'section--gutter': {
    ...grid({ colSpan: 12, columns: 12 }),
    [breakTo('small')]: {
      ...grid({ colSpan: 3, columns: 12 })
    }
  },

  'section--left': {
    ...grid({ colSpan: 12, columns: 12 }),

    padding: '0 2rem',

    [breakTo('small')]: {
      ...grid({ colSpan: 5, columns: 12 }),
      padding: '0'
    }
  },

  'section--center': {
    ...grid({ colSpan: 0, columns: 12 }),
    [breakTo('small')]: {
      ...grid({ colSpan: 1, columns: 12 })
    }
  },

  'section--right': {
    ...grid({ colSpan: 12, columns: 12 }),

    padding: '0 2rem',

    [breakTo('small')]: {
      ...grid({ colSpan: 2, columns: 12 }),
      marginTop: '0',
      padding: '0',
      whiteSpace: 'nowrap'
    }
  },

  label: {
    fontSize: '1.125rem',
    fontWeight: fontWeights.semibold,
    lineHeight: '1.2',

    display: 'block',

    width: '100%',
    marginTop: '2.4rem',
    marginRight: '1.5rem',

    color: colors.footer.label
  },
  copyright: {
    fontSize: '.65rem',
    paddingBottom: '2.5rem',
    paddingTop: '3.5rem',
    textAlign: 'justify',
    color: '#7FA2B6',//colors.footer.copyright,
    maxWidth: '70rem',
    float:'left',
    width: '80%',
    paddingLeft: '9%'
  },
sellalogo:{
  float: 'right',
  paddingRight: '10%',
  paddingTop: '3.5rem',
  backgroundImage: images.logoSella,
  backgroundRepeat: 'no-repeat',
  marginTop: '3.5rem'
},
MainContainer: {
  color: '#00466E',
  height: '100%',
  width: '90%',
  fontSize: '0'
},
leftAlign: {
  display: 'inline-block',
  color: '#7FA2B6',
  width: '95%',
  textAlign: 'justify',
  verticalAlign: 'middle',
  fontSize: '10px',
  // padding: '65px 65px 65px 80px'
  padding: '5% 0% 5% 20%'
},
centerAlign: {
  display: 'inline-block',
  color: '#7FA2B6',
  width: '80%',
  textAlign: 'center',
  verticalAlign: 'middle',
  fontSize: '10px',
  // padding: '65px 65px 65px 80px'
  padding: '0% 0% 5% 20%'
},
planTextAlign: {
  display: 'inline-block',
  color: '#7FA2B6',
  width: '85%',
  textAlign: 'justify',
  verticalAlign: 'middle',
  fontSize: '9px',
  // padding: '65px 65px 65px 80px'
  padding: '5% 0% 0% 20%'
},
rightAlign: {
  display: 'inline-block',
  width: '20%',
  backgroundImage: images.logoSella,
  backgroundPosition: 'right',
  backgroundRepeat: 'no-repeat',
  verticalAlign: 'middle',
  padding: '15px'
},

  disclaimer: {
    fontSize: '.8125rem',
    fontWeight: fontWeights.normal,
    lineHeight: '1.6',

    letterSpacing: '1.2',

    color: colors.footer.text,

    '> a': {
      color: colors.footer.linkAlt,

      ':hover': {
        color: colors.footer.linkAltHover
      }
    }
  },

  // This footer element shows a logo image.
  logo: {
    display: 'block',

    width: '76px',
    maxWidth: '6rem',
    height: '62px',
    margin: `${spacings.default} auto ${spacings.x4}`,
    marginTop: '2rem',
    marginBottom: '0',
    paddingRight: spacings.x3,

    userSelect: 'none',
    // opacity: .1,

    backgroundImage: images.footer,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',

    [breakTo('small')]: {
      marginTop: '5.4rem'
    }
  },

  text: {
    fontSize: '1rem',
    fontWeight: fontWeights.normal,

    display: 'block',

    paddingBottom: spacings.default,

    color: colors.footer.text,

    ':nth-child(n+3)': {
      paddingTop: spacings.default
    }
  },

  strongText: {
    lineHeight: '1.3125rem',

    display: 'inline-block',

    margin: '.5rem 0'
  },

  socialIcon: {
    display: 'inline-block',

    userSelect: 'none',
    transition: 'all 300ms',

    fill: colors.footer.link,

    ':hover': {
      fill: colors.footer.linkHover
    },

    ':nth-child(n+2)': {
      marginLeft: spacings.x2
    }
  }
})



// WEBPACK FOOTER //
// ./components/footer/styles.js